/**
 * @flow
 * @relayHash eb5f850f8ee8cb7fd042107cd07c7e57
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type RejectTutorMutationVariables = {|
  input: {
    tutorId: string;
    clientMutationId?: ?string;
  };
|};
export type RejectTutorMutationResponse = {|
  +rejectTutor: ?{|
    +clientMutationId: ?string;
  |};
|};
*/


/*
mutation RejectTutorMutation(
  $input: RejectTutorMutationInput!
) {
  rejectTutor(input: $input) {
    clientMutationId
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "RejectTutorMutationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectTutorMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "RejectTutorMutationInput!"
          }
        ],
        "concreteType": "RejectTutorMutationPayload",
        "name": "rejectTutor",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "RejectTutorMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "RejectTutorMutationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "RejectTutorMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "RejectTutorMutationInput!"
          }
        ],
        "concreteType": "RejectTutorMutationPayload",
        "name": "rejectTutor",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation RejectTutorMutation(\n  $input: RejectTutorMutationInput!\n) {\n  rejectTutor(input: $input) {\n    clientMutationId\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/mutations/__generated__/RejectTutorMutation.graphql.js